import React from 'react';
import { connect } from 'react-redux';
import { graphql, StaticQuery } from 'gatsby';
import { Row, Column, Button, TextInput, Checkbox, Select, Alert } from '@pella/sash-framework';
import AddressValidation from '../../../common/address-validation/v3';
import { isValidEmail, isValidPostal } from '../../../utilities/validations';

import PropTypes from 'prop-types';

// Constants
const SINGLE_REQUIRED_ERROR = ' is a required field';
const MULTI_REQUIRED_ERROR = ' are required fields';
const PHONE_NUMBER_ERROR = 'Enter a valid phone number';
const INVALID_EMAIL_ERROR = 'Enter a valid email address';

import { removePhoneNumberFormat } from '../../../utilities/functions';
import styles from './index.module.scss';
import { addDNCComments, submitDNC, resetDNCCalls } from '../../../../actions/dnc-actions';

class DoNotContact extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			doNotCall: false,
			doNotMail: false,
			doNotEmail: false,
			doNotSell: false,
			submit: false,
			error: false,
			Alert: false,
			dncSubmitted: false,
			reason0: false,
			reason1: false,
			reason2: false,
			reason3: false,
			reason4: false,
			reason5: false,
			reason6: false,
			reason6_1: false,
			improveSubmit: false,
			dncCommentsSubmitted: false,
			userAddress: {},
			userAddressComplete: false,
			userAddressModified: false,
			forceAddressValidation: false,
			fieldErrors: {},
			anotherIndividual: 'No',
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleNumberChange = this.handleNumberChange.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.validationError = this.validationError.bind(this);
		this.handleImproveSubmit = this.handleImproveSubmit.bind(this);
		this.onAddressStateChange = this.onAddressStateChange.bind(this);
	}

	componentDidMount() {
		this.props.resetDNCCalls();
	}

	componentDidUpdate(prevProps) {
		if (this.state.submit == true) {
			let dncSubmitArray = {
				firstname: this.state.firstName ? this.state.firstName : '',
				lastname: this.state.lastName ? this.state.lastName : '',
				address: this.state.userAddress.address1 ? this.state.userAddress.address1 : '',
				city: this.state.userAddress.city ? this.state.userAddress.city : '',
				state: this.state.userAddress.state ? this.state.userAddress.state : '',
				zip: this.state.userAddress.postalCode ? this.state.userAddress.postalCode : '',
				number: this.state.phonePref ? this.state.phonePref : '',
				email: this.state.email ? this.state.email : '',
				donotsell: this.state.doNotSell ? this.state.doNotSell : false,
				comments: this.state.anotherIndividual === 'Yes' ? `Relationship to individual: ${this.state.relationship}` : '',
			};

			this.props.submitDNC(dncSubmitArray);
			this.setState({
				dncSubmitted: true,
				submit: false,
			});
		}

		if (prevProps.dncData.RecID != this.props.dncData.RecID && this.props.dncData.RecID !== undefined) {
			this.setState({ RecId: this.props.dncData.RecID });
		}

		if (this.state.improveSubmit == true) {
			let comments = '';

			if (this.state.reason0 == true) {
				comments += 'reason0:I receive too much communication from Pella. ';
			}
			if (this.state.reason1 == true) {
				comments += 'reason1:I did not sign up to receive communication from Pella.';
			}
			if (this.state.reason2 == true) {
				comments += 'reason2: The content was irrelevant or not what I expected. ';
			}
			if (this.state.reason3 == true) {
				comments += 'reason3: I recently purchased from Pella. ';
			}
			if (this.state.reason4 == true) {
				comments += 'reason4: Privacy Concerns ';
			}
			if (this.state.reason5 == true) {
				comments += 'reason5: I purchased from a competitor and no longer wish to receive information from Pella. ';
			}
			if (this.state.reason6 == true) {
				comments += 'reason6: ' + this.state.reason6_1;
			}

			let dncComments = {
				comments: comments,
				recid: this.state.RecId,
			};

			this.props.addDNCComments(dncComments);

			this.setState({
				improveSubmit: false,
				dncCommentsSubmitted: true,
			});
		}
	}

	handleChange(e) {
		const field = e.target.name;
		const state = {};
		state[field] = e.target.value;

		state['error'] = null;
		state['Alert'] = false;
		this.setState(state);
	}

	handleNumberChange(field, value) {
		const state = {};
		state[field] = removePhoneNumberFormat(value);
		state['error'] = null;
		state['Alert'] = false;
		this.setState(state);
	}

	handleCheckboxChange(e) {
		const field = e.target.name;
		const state = {};
		state[field] = e.target.checked;
		state['error'] = null;
		state['Alert'] = false;
		this.setState(state);
	}

	onAddressStateChange(name, value) {
		this.setState({ [name]: value });
	}

	handleSubmit(e) {
		e.preventDefault();
		let error = null;
		let errorFields = [];
		let fieldErrors = {};

		if (!this.state.firstName || this.state.firstName == '') {
			errorFields.push('First Name');
			fieldErrors.firstName = 'First Name Required';
		}
		if (!this.state.lastName || this.state.lastName == '') {
			errorFields.push('Last Name');
			fieldErrors.lastName = 'Last Name Required';
		}
		if (!this.state.userAddress.address1 || this.state.userAddress.address1 === '') {
			errorFields.push('Street Address');
		}
		if (!this.state.userAddress.city || this.state.userAddress.city === '') {
			errorFields.push('City');
		}
		if (!this.state.userAddress.state || this.state.userAddress.state === '') {
			errorFields.push('State');
		}
		if (!isValidPostal(this.state.userAddress.postalCode)) {
			errorFields.push('Postal Code');
		}
		if (!this.state.phonePref || this.state.phonePref == '') {
			errorFields.push('Phone Number');
			fieldErrors.phonePref = 'Phone Number Required';
		} else if (this.state.phonePref.replace(/\_/g, '').length !== 10) {
			errorFields.push('Phone Number');
			fieldErrors.phonePref = PHONE_NUMBER_ERROR;
		}
		if (!this.state.email || this.state.email == '' || (this.state.email && !isValidEmail(this.state.email))) {
			errorFields.push('Email');
			fieldErrors.email = 'Email Required';
		}
		if (!this.state.emailConfirm || this.state.emailConfirm == '') {
			errorFields.push('Confirm Email');
			fieldErrors.emailConfirm = 'Confirmation Email Required';
		}
		if (this.state.email != this.state.emailConfirm) {
			errorFields.push('Confirm Email');
			fieldErrors.emailConfirm = 'Confirmation Email Needs To Match';
		}

		if (errorFields.length > 0) {
			for (let i = 0; i < errorFields.length; i++) {
				if (i === 0) {
					error = errorFields[i];
				} else {
					error += ', ' + errorFields[i];
				}
			}
			error += errorFields.length === 1 ? SINGLE_REQUIRED_ERROR : MULTI_REQUIRED_ERROR;
			this.validationError(error);
			this.setState({ forceAddressValidation: true, fieldErrors: fieldErrors });
			const anchor = document.getElementById('dnc_top');
			window.scrollTo({ top: anchor?.offsetTop || 0, left: 0, behavior: 'smooth' });
			return;
		}
		this.setState({
			submit: true,
		});
		window.scrollTo({ top: 0, left: 0 });
	}

	handleImproveSubmit(e) {
		e.preventDefault();

		let error = null;
		let errorFields = [];

		if (!this.state.reason0 && !this.state.reason1 && !this.state.reason2 && !this.state.reason3 && !this.state.reason4 && !this.state.reason5 && !this.state.reason6) {
			window.location.assign('http://www.pella.com');
		}

		if (this.state.reason6 == true && this.state.reason6_1 == '') {
			errorFields.push('Other - Reason');
		}

		if (errorFields.length > 0) {
			for (let i = 0; i < errorFields.length; i++) {
				if (i === 0) {
					error = errorFields[i];
				} else {
					error += ', ' + errorFields[i];
				}
			}
			error += errorFields.length === 1 ? SINGLE_REQUIRED_ERROR : MULTI_REQUIRED_ERROR;
			this.validationError(error);
			return;
		}

		this.setState({
			improveSubmit: true,
		});
	}

	validationError(error) {
		this.setState({
			Alert: true,
			error: error,
		});
	}

	render() {
		return (
			<StaticQuery
				query={query}
				render={(data) => (
					<div id='dnc_top'>
						{this.state.Alert && (
							<Alert
								type='error'
								hideClose
								className='mb-4 text-center'
							>
								{this.state.error}
							</Alert>
						)}
						<Row>
							{this.state.dncSubmitted == false && (
								<Column xs='12'>
									<Row>
										<>
											<Column xs='12'>
												<TextInput
													id='firstName'
													type='text'
													onChange={this.handleChange}
													autoComplete='off'
													required
													error={this.state.fieldErrors.firstName ? true : false}
													errorText={this.state.fieldErrors.firstName}
													labelText='First Name'
												/>
											</Column>
											<Column xs='12'>
												<TextInput
													id='lastName'
													type='text'
													onChange={this.handleChange}
													autoComplete='off'
													required
													error={this.state.fieldErrors.lastName ? true : false}
													errorText={this.state.fieldErrors.lastName}
													labelText='Last Name'
												/>
											</Column>
										</>

										<>
											<p className='pb-5'>The email address you provide may be used to 1) search Pella databases, 2) confirm your identity, 3) communicate with you regarding this request</p>
											<Column xs='12'>
												<TextInput
													id='email'
													type='text'
													onChange={this.handleChange}
													autoComplete='off'
													required
													error={this.state.fieldErrors.email ? true : false}
													errorText={this.state.fieldErrors.email}
													labelText='Email'
												/>
											</Column>
											<Column xs='12'>
												<TextInput
													id='emailConfirm'
													type='text'
													onChange={this.handleChange}
													autoComplete='off'
													required
													error={this.state.fieldErrors.emailConfirm ? true : false}
													errorText={this.state.fieldErrors.emailConfirm}
													labelText='Confirm Email'
												/>
											</Column>
										</>

										<>
											<Column>
												<AddressValidation
													allowInternational
													addressComplete={[this.state.userAddressComplete, (value) => this.onAddressStateChange('userAddressComplete', value)]}
													addressInputs={{
														line1: {
															label: 'Street Address',
															xs: 12,
														},
														line2: { visible: true, xs: 12 },
														city: { xs: 12 },
														state: { xs: 12 },
														postalCode: { xs: 12 },
													}}
													addressInput={{}}
													addressOutput={[this.state.userAddress, (value) => this.onAddressStateChange('userAddress', value)]}
													addressModified={[this.state.userAddressModified, (value) => this.onAddressStateChange('userAddressModified', value)]}
													addressValidate={[this.state.forceAddressValidation, (value) => this.onAddressStateChange('forceAddressValidation', value)]}
													className={styles.dnc_results}
												/>
											</Column>
										</>

										<>
											<Column xs='12'>
												<TextInput
													id='phonePref'
													type='tel'
													format='(###) ###-####'
													allowEmptyFormatting
													onValueChange={(values) => this.handleNumberChange('phonePref', values.formattedValue)}
													autoComplete='off'
													required
													error={this.state.fieldErrors.phonePref ? true : false}
													errorText={this.state.fieldErrors.phonePref}
													labelText='Phone Number'
												/>
											</Column>
										</>
									</Row>
									<Row>
										<Column xs='12'>
											<p className='pb-4 pt-2.5'>
												<strong>Type of Request</strong> (Select all that apply)
											</p>
										</Column>
									</Row>
									<Row>
										<Column xs='12'>
											<Checkbox
												type='checkbox'
												id='doNotMail'
												name='doNotMail'
												group='contactPref'
												labelText='Opt-out of mailings'
												defaultChecked={this.state.doNotMail}
												onChange={this.handleCheckboxChange}
											/>
											<Checkbox
												type='checkbox'
												id='doNotCall'
												name='doNotCall'
												group='contactPref'
												labelText='Opt-out of calls'
												defaultChecked={this.state.doNotCall}
												onChange={this.handleCheckboxChange}
											/>
											<Checkbox
												type='checkbox'
												id='doNotEmail'
												name='doNotEmail'
												group='contactPref'
												labelText='Opt-out of emails'
												defaultChecked={this.state.doNotEmail}
												onChange={this.handleCheckboxChange}
											/>
											<Checkbox
												type='checkbox'
												id='doNotSell'
												name='doNotSell'
												group='contactPref'
												labelText='Opt-out of the sale and sharing of my personal information to third parties'
												defaultChecked={this.state.doNotSell}
												onChange={this.handleCheckboxChange}
											/>
											<ul className='list-none'>
												<li>Access my personal information</li>
												<li>Confirm my personal information</li>
												<li>Correct my personal information</li>
												<li>Delete my personal information</li>
												<li>Limit the use of my sensitive personal information</li>
												<li>Receive information about onward disclosures</li>
											</ul>
											<p>Are you making this request on behalf of another individual?</p>
											<div className='flex flex-row gap-x-8 pt-4'>
												<Checkbox
													labelText='Yes'
													name='anotherIndividual'
													type='radio'
													onChange={this.handleChange}
													value='Yes'
												/>
												<Checkbox
													labelText='No'
													name='anotherIndividual'
													defaultChecked
													type='radio'
													onChange={this.handleChange}
													value='No'
												/>
											</div>

											<p className='pb-4'>If yes, please explain your relationship to that individual.</p>
											<TextInput
												type='text'
												name='relationship'
												onChange={this.handleChange}
												theme='redesign'
											/>

											<Button
												color='primary'
												size='md'
												type='submit'
												className='mb-5'
												onClick={this.handleSubmit}
												data-gtm-linktype='button'
												data-gtm-linktext='Unsubscribe'
											>
												Submit
											</Button>
										</Column>
									</Row>
									<Row>
										<Column xs='12'>
											{
												<div
													dangerouslySetInnerHTML={{
														__html: data.contentstackDncConfig.introduction,
													}}
												/>
											}
										</Column>
									</Row>
								</Column>
							)}

							{this.state.dncSubmitted == true && (
								<Column xs={12}>
									<Row>
										{data.contentstackDncConfig.confirmations[0] && data.contentstackDncConfig.confirmations[0].heading && (
											<div>
												<h2 className='text-2xl'>{data.contentstackDncConfig.confirmations[0].heading}</h2>
											</div>
										)}

										{this.state.doNotMail == true && (
											<Column xs='12'>
												{data.contentstackDncConfig.confirm_text && data.contentstackDncConfig.confirm_text[0] && (
													<div
														dangerouslySetInnerHTML={{
															__html: data.contentstackDncConfig.confirm_text[0],
														}}
													/>
												)}
											</Column>
										)}

										{this.state.doNotCall == true && (
											<Column xs='12'>
												{data.contentstackDncConfig.confirm_text && data.contentstackDncConfig.confirm_text[2] && (
													<div
														dangerouslySetInnerHTML={{
															__html: data.contentstackDncConfig.confirm_text[2],
														}}
													/>
												)}
											</Column>
										)}

										{this.state.doNotEmail == true && (
											<Column xs='12'>
												{data.contentstackDncConfig.confirm_text && data.contentstackDncConfig.confirm_text[1] && (
													<div
														dangerouslySetInnerHTML={{
															__html: data.contentstackDncConfig.confirm_text[1],
														}}
													/>
												)}
											</Column>
										)}

										<Column xs='12'>
											{data.contentstackDncConfig.confirmations[0] && data.contentstackDncConfig.confirmations[0].description && (
												<div
													className='pb-4 pt-2.5'
													dangerouslySetInnerHTML={{
														__html: data.contentstackDncConfig.confirmations[0].description,
													}}
												/>
											)}
										</Column>
									</Row>

									{this.state.dncSubmitted == true && this.state.dncCommentsSubmitted == false && (
										<>
											<Row>
												{data.contentstackDncConfig.confirmations[1] && data.contentstackDncConfig.confirmations[1].heading && (
													<div>
														<h3>{data.contentstackDncConfig.confirmations[1].heading}</h3>
													</div>
												)}
											</Row>
											<Row>
												{data.contentstackDncConfig.confirmations[1] && data.contentstackDncConfig.confirmations[1].description && (
													<div
														dangerouslySetInnerHTML={{
															__html: data.contentstackDncConfig.confirmations[1].description,
														}}
													/>
												)}

												<Column
													className='pb-5'
													sm='12'
												>
													<Checkbox
														type='checkbox'
														id='reason0'
														name='reason0'
														group='improveComm'
														labelText='I receive too much communication from Pella.'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='12'
												>
													<Checkbox
														type='checkbox'
														id='reason1'
														name='reason1'
														group='improveComm'
														labelText='I did not sign up to receive communication from Pella.'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='12'
												>
													<Checkbox
														type='checkbox'
														id='reason2'
														name='reason2'
														group='improveComm'
														labelText='The content was irrelevant or not what I expected.'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='12'
												>
													<Checkbox
														type='checkbox'
														id='reason3'
														name='reason3'
														group='improveComm'
														labelText='I recently purchased from Pella.'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='12'
												>
													<Checkbox
														type='checkbox'
														id='reason4'
														name='reason4'
														group='improveComm'
														labelText='Privacy Concerns'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='12'
												>
													<Checkbox
														type='checkbox'
														id='reason5'
														name='reason5'
														group='improveComm'
														labelText='I purchased from a competitor and no longer wish to receive information from Pella.'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='2'
												>
													<Checkbox
														type='checkbox'
														id='reason6'
														name='reason6'
														group='improveComm'
														labelText='Other'
														onChange={this.handleCheckboxChange}
													/>
												</Column>
												<Column
													className='pb-5'
													sm='6'
												>
													<TextInput
														id='reason6_1'
														name='reason6_1'
														group='improveComm'
														type='text'
														onChange={this.handleChange}
														autoComplete='off'
														size='sm'
														noWrapper
														required
													/>
												</Column>
												<Column sm='12'>
													<Button
														color='primary'
														size='md'
														type='submit'
														onClick={this.handleImproveSubmit}
														data-gtm-linktype='button'
														data-gtm-linktext='Submit'
													>
														Submit
													</Button>
												</Column>
											</Row>
										</>
									)}

									{this.state.dncCommentsSubmitted == true && (
										<Row>
											{data.contentstackDncConfig.confirm_text && data.contentstackDncConfig.confirm_text[3] && (
												<div
													dangerouslySetInnerHTML={{
														__html: data.contentstackDncConfig.confirm_text[3],
													}}
												/>
											)}
										</Row>
									)}
								</Column>
							)}
						</Row>
					</div>
				)}
			/>
		);
	}
}

DoNotContact.propTypes = {
	data: PropTypes.object,
	dncData: PropTypes.object,
	addDNCComments: PropTypes.func.isRequired,
	resetDNCCalls: PropTypes.func.isRequired,
	submitDNC: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
	dncData: state.dncData,
});

export default connect(mapStateToProps, {
	addDNCComments,
	submitDNC,
	resetDNCCalls,
})(DoNotContact);

export const query = graphql`
	query {
		contentstackDncConfig {
			confirm_text
			confirmations {
				description
				heading
			}
			introduction
			title
		}
	}
`;
